/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeepHealthResponse } from '../models/DeepHealthResponse';
import type { HealthResponse } from '../models/HealthResponse';
import type { SystemStatusResponse } from '../models/SystemStatusResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SystemService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Health
     * Shallow, for a load balancer. Touches nothing.
     *
     * Deliberately does not check the database: a health endpoint that fails when Postgres
     * is briefly unreachable makes the proxy remove the instance, which removes the UI that
     * would have shown what is wrong. `/health/deep` is the one that reports dependencies.
     * @returns HealthResponse Successful Response
     * @throws ApiError
     */
    public health(): CancelablePromise<HealthResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/health',
        });
    }
    /**
     * Health Deep
     * Every dependency, with detail. Unauthenticated by design.
     *
     * Booleans, a reason, the service name and its version — never a DSN, a host or a
     * credential, because this response is not behind the redaction filter.
     * @returns DeepHealthResponse Successful Response
     * @throws ApiError
     */
    public healthDeep(): CancelablePromise<DeepHealthResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/health/deep',
        });
    }
    /**
     * System Status
     * What the rail shows. One Redis read per service and two cheap indexed queries.
     * @returns SystemStatusResponse Successful Response
     * @throws ApiError
     */
    public systemStatus(): CancelablePromise<SystemStatusResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/system/status',
        });
    }
}
